export default class EventEmitter {

    static emit(name, detail = {}){
        const event = new CustomEvent(name, {detail})
        document.dispatchEvent(event)
        return event
    }

    static on(name, callback = () => {}) {
        document.addEventListener(name, e => callback(e))
    }

}